import { Button } from '@kerfjs/ui/button';
import { Toolbar } from '@kerfjs/ui/toolbar';
import { type SafeHtml } from 'kerfjs';

import { settingsPage, settingsTab } from '../../data/state.js';
import { ACTING_READ_ONLY_REASON, actingReadOnly } from '../../lib/acting-read-only.js';
import type { SettingsTab } from '../../lib/context.js';
import type { SettingsPage } from '../../lib/settings-nav.js';

export interface SettingsSaveAction {
  action: 'save-profile' | 'save-thresholds' | 'save-assumptions';
  label: string;
}

/** Pages with explicit saves; other settings save on change or have no form. */
export function settingsFooterAction(area: SettingsTab, page: SettingsPage): SettingsSaveAction | null {
  if (area !== 'organization') return null;
  switch (page) {
    case 'profile':
      return { action: 'save-profile', label: 'Save Profile' };
    case 'verdict-thresholds':
      return { action: 'save-thresholds', label: 'Save Thresholds' };
    case 'landed-cost':
      return { action: 'save-assumptions', label: 'Save Assumptions' };
    default:
      return null;
  }
}

/** Main-column footer; shell mounts it on settings pages with an explicit save. */
export function SettingsFooter({
  area = settingsTab.value,
  page = settingsPage.value,
}: { area?: SettingsTab; page?: SettingsPage } = {}): SafeHtml {
  const save = settingsFooterAction(area, page);
  if (save === null) return <></>;
  return (
    <Toolbar
      label="Settings Actions"
      dividerSides="t"
      trailing={
        <Button
          size="default"
          type="button"
          tone="brand"
          emphasis="primary"
          action={save.action}
          disabled={actingReadOnly()}
          title={actingReadOnly() ? ACTING_READ_ONLY_REASON : undefined}
        >
          {save.label}
        </Button>
      }
    />
  );
}
